<section class="developers-page container">
  <h1 class="developers-page__header">
    {{ 'header.forDevelopersOwners' | translate }}
  </h1>
  <div class="developers-page__content">
    <pwj-solutions-people-browse
      filterType="PROJECT_OWNER"
      noContentMessageKey="industries.noIndustries" />
  </div>
</section>
